import API from './api';

export const downloadAuditLogs = async (): Promise<Blob> => {
  const response = await API({ feedbackMode: 'off' }).get('/admin/audit/logs', {
    responseType: 'blob',
  });
  return response.data;
};

export const clearAuditLogs = async (): Promise<void> => {
  await API({ feedbackMode: 'auto' }).delete('/admin/audit/logs');
};
